// extracted by mini-css-extract-plugin
export default {"isHidden":"isHidden___3FhmU"};